// =====================================================================
// Workspace-scoped settings (Sprint 3 Phase 3G-v.d, 2026-05-31)
// =====================================================================
// SMTP defaults the dispatcher falls back to when a NotificationChannel
// leaves its smtp_* fields null. Stored at
// /workspaces/{wid}/settings/smtp_defaults; managed by workspace_admin
// via the portal so single-tenant deployments don't need env vars and
// multi-tenant deployments can keep different mailbox credentials per
// workspace.
//
// Resolution order in the dispatcher:
//   per-channel field → workspace doc field → cloud-api env var
// =====================================================================

import { z } from 'zod';

export const WorkspaceSmtpDefaultsSchema = z.object({
  smtp_host: z.string().nullable(),
  smtp_port: z.number().int().min(1).max(65535).nullable(),
  smtp_user: z.string().nullable(),
  smtp_pass: z.string().nullable(),
  smtp_from: z.string().nullable(),
  require_tls: z.boolean().nullable(),
  updated_at_ms: z.number().int().nonnegative(),
});
export type ParsedWorkspaceSmtpDefaults = z.infer<typeof WorkspaceSmtpDefaultsSchema>;

export const UpdateWorkspaceSmtpDefaultsSchema = z.object({
  smtp_host: z.string().nullable().optional(),
  smtp_port: z.number().int().min(1).max(65535).nullable().optional(),
  smtp_user: z.string().nullable().optional(),
  smtp_pass: z.string().nullable().optional(),
  smtp_from: z.string().nullable().optional(),
  require_tls: z.boolean().nullable().optional(),
});
export type ParsedUpdateWorkspaceSmtpDefaults = z.infer<typeof UpdateWorkspaceSmtpDefaultsSchema>;
